import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import Router from './Router';
import i18n from './i18n';

import { ThemeProvider, Theme } from './contexts/ThemeContext';

import './index.scss';

// Get theme from URL before rendering to prevent flash
const getInitialTheme = (): Theme => {
  const params = new URLSearchParams(window.location.search);
  const theme = params.get('theme');
  if (theme === 'dark' || theme === 'light') {
    return theme;
  }
  return 'light';
};

const initialTheme = getInitialTheme();

// Apply theme immediately to prevent flash
document.documentElement.setAttribute('data-theme', initialTheme);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <ThemeProvider initialTheme={initialTheme}>
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
);
